<mat-tab-group class="card p-3" animationDuration="0ms" [preserveContent]="true"  (selectedTabChange)="tabChanged($event)" [selectedIndex]="activeTabIndex">
  @for (tab of tabs; track tab; let i = $index) {
    <mat-tab label="{{tab.title}}">
      <ng-template matTabContent>
        @if (displayByModes && tab.displayMode === tabActiveMode) {
          <ng-template *ngTemplateOutlet="this['tab' + (i + 1)]"></ng-template>
          @if (tab.html) {
            <div class="row" [innerHTML]="tab.html | replaceTokensArray: {keys: tab.html} |safe: 'html'" ></div>
          }
        }
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>

<ng-template #tab1>
  <ng-content select=".tab1"></ng-content>
</ng-template>
<ng-template #tab2>
  <ng-content select=".tab2"></ng-content>
</ng-template>
<ng-template #tab3>
  <ng-content select=".tab3"></ng-content>
</ng-template>
<ng-template #tab4>
  <ng-content select=".tab4"></ng-content>
</ng-template>
<ng-template #tab5>
  <ng-content select=".tab5"></ng-content>
</ng-template>
<ng-template #tab6>
  <ng-content select=".tab6"></ng-content>
</ng-template>
<ng-template #tab7>
  <ng-content select=".tab7"></ng-content>
</ng-template>
<ng-template #tab8>
  <ng-content select=".tab8"></ng-content>
</ng-template>
<ng-template #tab9>
  <ng-content select=".tab9"></ng-content>
</ng-template>
<ng-template #tab10>
  <ng-content select=".tab10"></ng-content>
</ng-template>
<ng-template #tab11>
  <ng-content select=".tab11"></ng-content>
</ng-template>
